import {
    EXPORT_ZOOM_CLEAN_LOGGING_FAILURE,
    EXPORT_ZOOM_CLEAN_LOGGING_REQUEST, EXPORT_ZOOM_CLEAN_LOGGING_SUCCESS,
    EXPORT_ZOOM_LOGGING_FAILURE,
    EXPORT_ZOOM_LOGGING_REQUEST,
    EXPORT_ZOOM_LOGGING_SUCCESS,
    FETCH_ZOOM_CLEAN_LOGGING_FAILURE,
    FETCH_ZOOM_CLEAN_LOGGING_REQUEST,
    FETCH_ZOOM_CLEAN_LOGGING_SUCCESS,
    FETCH_ZOOM_LOGGING_FAILURE,
    FETCH_ZOOM_LOGGING_REQUEST,
    FETCH_ZOOM_LOGGING_SUCCESS,
} from '../../actions/admin/zoom-logging.action';
import { formatDateFunc, sortArray } from '../../utils/common';


const initialState = {
    log: [], loading: false, error: '', cleanLog: [],
};

const ZoomLoggingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ZOOM_LOGGING_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_ZOOM_LOGGING_SUCCESS:
            return {
                ...state,
                updatedDateTime: formatDateFunc(new Date()),
                loading: false,
                log: sortArray(action.payload, 'eventTimestamp'),
            };
        case FETCH_ZOOM_LOGGING_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case EXPORT_ZOOM_LOGGING_REQUEST:
            return { ...state, loading: true, error: null };
        case EXPORT_ZOOM_LOGGING_SUCCESS:
            return {
                ...state, loading: false, error: '',
            };
        case EXPORT_ZOOM_LOGGING_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case FETCH_ZOOM_CLEAN_LOGGING_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_ZOOM_CLEAN_LOGGING_SUCCESS:
            return {
                ...state,
                updatedDateTime: formatDateFunc(new Date()),
                loading: false,
                cleanLog: sortArray(action.payload, 'eventTimestamp'),
            };
        case FETCH_ZOOM_CLEAN_LOGGING_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case  EXPORT_ZOOM_CLEAN_LOGGING_REQUEST:
            return { ...state, loading: true, error: null };
        case  EXPORT_ZOOM_CLEAN_LOGGING_SUCCESS:
            return {
                ...state, loading: false, error: '',
            };
        case  EXPORT_ZOOM_CLEAN_LOGGING_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default ZoomLoggingReducer;